var $9b03ddc410693513$exports = {};
'use strict';
// service we have section 
const $9b03ddc410693513$var$ul = document.getElementById("mainList");
const $9b03ddc410693513$var$liList = $9b03ddc410693513$var$ul.querySelectorAll("li");
const $9b03ddc410693513$var$imageList = document.querySelectorAll(".hiddenImage");
$9b03ddc410693513$var$ul.addEventListener("click", (event)=>{
    const { id: id } = event.target;
    $9b03ddc410693513$var$liList.forEach((e)=>{
        if (e.id === id) e.classList?.add("underlines");
        else e.classList?.remove("underlines");
    });
    const sectionId = id.split("_")[1];
    $9b03ddc410693513$var$imageList.forEach((e)=>{
        if (e.id === sectionId) e.classList?.add("visibleImage");
        else e.classList?.remove("visibleImage");
    });
});
// counter
const $9b03ddc410693513$var$counters = document.querySelectorAll('.counter');
const $9b03ddc410693513$var$speed = 200; // The lower the slower
$9b03ddc410693513$var$counters.forEach((counter)=>{
    const updateCount = ()=>{
        const target = +counter.getAttribute('data-target');
        const count = +counter.innerText;
        // Lower inc to slow and higher to slow
        const inc = target / $9b03ddc410693513$var$speed;
        // Check if target is reached
        if (count < target) {
            // Add inc to count and output in counter
            counter.innerText = count + inc;
            // Call function every ms
            setTimeout(updateCount, 1);
        } else counter.innerText = target;
    };
    updateCount();
});


//# sourceMappingURL=amazon-web-services.afbc1b2a.js.map
